import { DocumentationArea } from "src/contexts/documentationArea/domain/DocumentationArea";
import { DOCUMENTATION_AREA_ROUTES } from "./Navigation";

export function getDocumentationAreaPath(
  documentationArea: DocumentationArea,
  hasSignedAcceptance: boolean,
  isActorBasicDataFullfilled?: boolean,
): string {
  if (!hasSignedAcceptance) {
    return DOCUMENTATION_AREA_ROUTES.CONSENTS;
  }

  const shouldShowBasicData =
    typeof isActorBasicDataFullfilled === "boolean"
      ? !isActorBasicDataFullfilled
      : !documentationArea.hasMinimumDataProvided();

  if (shouldShowBasicData) {
    return DOCUMENTATION_AREA_ROUTES.BASIC_DATA;
  }

  return DOCUMENTATION_AREA_ROUTES.HOME;
}
